var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import React from 'react';
import { useAppSelector } from '../../store/app.store';
/*import {
  npDetailsSelectorById,
} from '../../Store/Slices/NonProjectHoursSlice';*/
import { Stack, Text } from '@fluentui/react';
import { npDetailsSelectorById } from '../../store/Slices/AssignmentDetailsSlice';
export const NonProjectHeaderComponent = (props) => {
    const data = useAppSelector(npDetailsSelectorById(props.nprequestId));
    // const data: NonProject | PublicHoliday = 
    //   {
    //     nonProjectId: 414253,
    //     eventName: 'Appointment',
    //     status: 'Confirmed',
    //     isRecurrent: true,
    //     recurrencePattern: RecurrencePattern.daily,
    //     recurrenceEndsAfter: 5,
    //     recurrenceEndsBy: '2024-02-14T17:00:00',
    //     forecastSchedule: [
    //       {
    //         id: '',
    //         fiscalWeekStartDate: '0001-01-01T00:00:00',
    //         forecastDate: '2024-02-10T09:00:00',
    //         durationInHours: 8,
    //       },
    //       {
    //         id: '',
    //         fiscalWeekStartDate: '0001-01-01T00:00:00',
    //         forecastDate: '2024-02-11T09:00:00',
    //         durationInHours: 8,
    //       },
    //       {
    //         id: '',
    //         fiscalWeekStartDate: '0001-01-01T00:00:00',
    //         forecastDate: '2024-02-12T09:00:00',
    //         durationInHours: 8,
    //       },
    //       {
    //         id: '',
    //         fiscalWeekStartDate: '0001-01-01T00:00:00',
    //         forecastDate: '2024-02-13T09:00:00',
    //         durationInHours: 8,
    //       },
    //       {
    //         id: '',
    //         fiscalWeekStartDate: '0001-01-01T00:00:00',
    //         forecastDate: '2024-02-14T09:00:00',
    //         durationInHours: 8,
    //       },
    //     ],
    //     comments: 'aa',
    //   } // Mock data for demonstration
    return !!data || props.isVacation || props.isOutlook ? (React.createElement(Stack, { verticalAlign: 'center' },
        React.createElement(Stack, { horizontal: true, tokens: { childrenGap: 10 }, horizontalAlign: "space-between" },
            !!props.isPublicHoliday && (React.createElement(Text, { style: { fontSize: '16px' } }, data.eventName)),
            !!props.isNonProject && (React.createElement(Text, { style: { fontSize: '16px' } }, data.eventName)),
            !!props.isVacation && (React.createElement(Text, { style: { fontWeight: '600', fontSize: '16px' } }, "Time Away")),
            !!props.isOutlook && (React.createElement(Text, { style: { fontWeight: '600', fontSize: '16px' } }, "Outlook"))),
        React.createElement(Text, { block: true, style: { overflowWrap: 'break-word', wordBreak: 'break-word' } },
            ' ',
            props.isNonProject && data.customProperties.comments,
            ' ',
            props.isPublicHoliday === true ? 'Public Holiday' : ''))) : null;
};
//# sourceMappingURL=NonProjectHeaderComponent.js.map